import {
  Box,
  Grid,
  Paper,
  Table,
  TableBody,
  TableHead,
  Tooltip,
} from "@mui/material";
import {
  OutlinedIconFab,
  StyledTableCellHistory,
  StyledTableContainer,
  StyledTableRowHistory,
} from "../StyledComponents";
import Icon from "../Utils/Icons";
import { getDefaultFieldLayout } from "../config/defaults/fieldLayoutUtils";

const DEFAULT_COLUMN_RENDER = {
  term: (row) => (
    <>
      {row?.term}
      {row?.source === "voice" && !row.id && (
        <Tooltip title="Machine-interpreted text — please verify before confirming">
          <span className="missing-id-warning">⚠️</span>
        </Tooltip>
      )}
    </>
  ),
  clinical_note: (row) => row?.clinical_note || "-",
};

export const ProceduresTable = ({
  data,
  activeSection,
  handleEditRow = () => { },
  handleDeleteRow = () => { },
  fieldLayout: fieldLayoutProp,
}) => {
  const fieldLayout = fieldLayoutProp || getDefaultFieldLayout("procedureRow");

  if (!data || data.length === 0) return null;

  const columns = fieldLayout.tableColumns || [];

  return (
    <>
      {data.length > 0 && (
        <Grid item xs={12} md={6}>
          <StyledTableContainer component={Paper}>
            <Table>
              <TableHead>
                <StyledTableRowHistory>
                  {columns.map((column) => (
                    <StyledTableCellHistory key={column.key}>
                      {column.label}
                    </StyledTableCellHistory>
                  ))}
                  {activeSection && (
                    <StyledTableCellHistory>Actions</StyledTableCellHistory>
                  )}
                </StyledTableRowHistory>
              </TableHead>
              <TableBody>
                {data.map((row, rowIndex) => (
                  <StyledTableRowHistory key={rowIndex}>
                    {columns.map((column) => (
                      <StyledTableCellHistory key={column.key}>
                        {(DEFAULT_COLUMN_RENDER[column.key] ||
                          ((r) => r?.[column.key]))(row)}
                      </StyledTableCellHistory>
                    ))}
                    {activeSection && (
                      <StyledTableCellHistory>
                        <Box sx={{ display: "flex", alignItems: "center" }}>
                          <OutlinedIconFab
                            onClick={() => handleEditRow(rowIndex)}
                            sx={{ marginRight: 1 }}
                          >
                            <Icon name="editInTable" size={32} />
                          </OutlinedIconFab>
                          <OutlinedIconFab
                            onClick={() => handleDeleteRow(rowIndex)}
                          >
                            <Icon name="deleteInTable" size={32} />
                          </OutlinedIconFab>
                        </Box>
                      </StyledTableCellHistory>
                    )}
                  </StyledTableRowHistory>
                ))}
              </TableBody>
            </Table>
          </StyledTableContainer>
        </Grid>
      )}
    </>
  );
};
